// Store for pending AI changes that need user approval
import { create } from 'zustand';

const usePendingChangesStore = create((set, get) => ({
    // Map of filePath -> { originalContent, newContent, description }
    pendingChanges: {},

    // Add a pending change
    addPendingChange: (filePath, originalContent, newContent, description = '', metadata = {}) => {
        set((state) => ({
            pendingChanges: {
                ...state.pendingChanges,
                [filePath]: {
                    originalContent,
                    newContent,
                    description,
                    ...metadata,
                    timestamp: new Date().toISOString()
                }
            }
        }));
    },

    // Get pending change for a file
    getPendingChange: (filePath) => {
        return get().pendingChanges[filePath] || null;
    },

    // Check if file has pending changes
    hasPendingChange: (filePath) => {
        return !!get().pendingChanges[filePath];
    },

    // Accept a change (apply it)
    acceptChange: (filePath) => {
        const change = get().pendingChanges[filePath];
        if (!change) return null;

        const newContent = change.newContent;

        // Remove from pending
        set((state) => {
            const { [filePath]: _, ...rest } = state.pendingChanges;
            return { pendingChanges: rest };
        });

        return newContent;
    },

    // Reject a change (discard it)
    rejectChange: (filePath) => {
        set((state) => {
            const { [filePath]: _, ...rest } = state.pendingChanges;
            return { pendingChanges: rest };
        });
    },

    // Accept all pending changes
    acceptAllChanges: () => {
        const changes = get().pendingChanges;
        set({ pendingChanges: {} });
        return changes;
    },

    // Reject all pending changes
    rejectAllChanges: () => {
        set({ pendingChanges: {} });
    },

    // Get count of pending changes
    getPendingCount: () => {
        return Object.keys(get().pendingChanges).length;
    },

    // Clear all pending changes
    clear: () => {
        set({ pendingChanges: {} });
    }
}));

export default usePendingChangesStore;
